import { WhenLoggedIn } from 'lib-core'


export default WhenLoggedIn
